import Vue from 'vue';
import trumbowyg from 'vue-trumbowyg';
// Import editor cssFcheckCompanyCloseDate
// import '@/static/trumbowyg.cleanpaste.js';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'trumbowyg/dist/ui/trumbowyg.css';

Vue.use(trumbowyg);
